import { render } from "./CoBrandPaper.vue?vue&type=template&id=76d1eeaf&scoped=true"
import script from "./CoBrandPaper.vue?vue&type=script&lang=js"
export * from "./CoBrandPaper.vue?vue&type=script&lang=js"

import "./CoBrandPaper.vue?vue&type=style&index=0&id=76d1eeaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d1eeaf"]])

export default __exports__